import { FC, useEffect, useState } from 'react';
import { GetApproversList, GetManager } from 'services/user-service';
import { Approver } from 'models/IApprover';
import { Select, Text } from '@nike/eds';
import ts from '../i18n';
import { useI18nContext } from 'context/language/use-i18n-context';

type option = {
  value: string;
  label: string;
};

type Props = {
  onApproverChange: (option: any) => void;
  noteText?: string;
};

export const Approvers: FC<Props> = ({ onApproverChange, noteText }) => {
  const [ApproversList, setApprovalsList] = useState<option[]>();
  const { i18nString } = useI18nContext();
  const [selectedApprover, setSelectedApprover] = useState<option>();

  useEffect(() => {
    const approvers = GetApproversList();
    const manager = GetManager();

    setApprovalsList(
      approvers?.map((approver: Approver) => ({ value: approver.id, label: approver.name })),
    );
    if (approvers && approvers.length > 0) {
      const managerApprover = approvers.find(x => x.id === manager?.id);
      if (managerApprover) {
        setSelectedApprover({ value: managerApprover.id, label: managerApprover.name });
        onApproverChange({ value: managerApprover.id, label: managerApprover.name });
      } else {
        setSelectedApprover({ value: approvers[0].id, label: approvers[0].name });
        onApproverChange({ value: approvers[0].id, label: approvers[0].name });
      }
    }
  }, []);

  const handleApproverChange = (option: option) => {
    onApproverChange(option);
    setSelectedApprover(option);
  };

  return (
    <section className="eds-background--white eds-spacing--p-20 section-border">
      <Text className="txt_uppercase eds-spacing--my-12 eds-spacing--mx-4" as={'h3'}>
        {i18nString(ts.PASS_MODAL_APPROVING_MANAGER)}
      </Text>
      <Select
        id="approvers"
        aria-label="approvers"
        data-testid="approvers"
        options={ApproversList}
        name="country"
        hideLabel={true}
        label={i18nString(ts.PASS_MODAL_APPROVING_MANAGER)}
        value={selectedApprover}
        onChange={(option: any) => handleApproverChange(option)}
      />
      {noteText && (
        <Text className="txt_italic eds-spacing--mt-12 eds-type--legal-1">{noteText}</Text>
      )}
    </section>
  );
};
